import { authPost } from '../../http';
import { GetMetric } from '../types';

export const getMetric = async (item: GetMetric) => {
  return await authPost(`api/v1/google_analytics/ga-metrics/`, item);
};
